// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__h9Zo2","inner":"Footer_inner__3xYoM"};